export enum XpassLocationLabels {
  BORACAY = 'Boracay',
  EL_NIDO = 'El Nido'
}
